import React, { useEffect, useState } from 'react';
import baseURL from '../../url';
import './ReservasData.css';

import { DateRange } from "react-date-range";
import { addDays, addYears } from "date-fns";
import es from "date-fns/locale/es";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUser,
    faPhone,
    faCalendarAlt,
    faFilter,
    faPlus,
    faTimes,
    faSearch
} from '@fortawesome/free-solid-svg-icons';

export default function ReservasData() {
    const [range, setRange] = useState([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 1),
        key: "selection",
      },
    ]);
    const [noches, setNoches] = useState(0);
    const [nochesTotal, setNochesTotal] = useState(0);
    const [detallePrecios, setDetallePrecios] = useState([]);
    const [reglas, setReglas] = useState([]);
    const [fechasNoDisponibles, setFechasNoDisponibles] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [productos, setProductos] = useState([]);
    const [producto, setProducto] = useState([]);
    const [productosAcomodacion, setProductosAcomodacion] = useState([]);
    const [categorias, setCategoras] = useState([]);

    const [reservas, setReservas] = useState([]);
    const [filtroNombre, setFiltroNombre] = useState("");
    const [filtroTelefono, setFiltroTelefono] = useState("");
    const [filtroFechaInicio, setFiltroFechaInicio] = useState("");
    const [filtroFechaFin, setFiltroFechaFin] = useState("");
    const [filtroProducto, setFiltroProducto] = useState("");

    const [modalOpen, setModalOpen] = useState(false);
    // Form modal
    const [nombre, setNombre] = useState("");
    const [noteText, setNoteText] = useState("");
    const [telefono, setTelefono] = useState("");
    const [productoNombre, setProductoNombre] = useState("");
    const [pago, setPago] = useState("");

    useEffect(() => {
        cargarCategoria();
        cargarProductos();
        cargarMetodosPago();
        cargarReservas();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

     const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarFechasNoDisponibles = (idProducto) => {
        setRange([
          {
            startDate: new Date(),
            endDate: addDays(new Date(), 1),
            key: "selection",
          },
        ]);
        fetch(`${baseURL}/getProductoReservas.php?idProducto=${idProducto}`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setFechasNoDisponibles(data.rangos.map(r => ({
                    start: new Date(r.start.y, r.start.m, r.start.d),
                    end:   new Date(r.end.y,   r.end.m,   r.end.d)
                })));
            })
            .catch(() => {});
    };

    const fechaOcupada = (date) => {
      return fechasNoDisponibles.some((range) => {
        return date >= range.start && date < addDays(range.end, 1); // comparar inclusive
      });
    };

    const esTemporadaAlta = (date) => {
      if (!reglas || reglas.length === 0) return false;

      const diasSemana = [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ];

      const nombreDia = diasSemana[date.getDay()]; // 0 = domingo
      const fechaFormato = date.toISOString().split("T")[0]; // YYYY-MM-DD

      return reglas.some((r) => {
        if (!r || !r.type || !r.value) return false;
        if (r.type === "weekday") {
          return r.value.toLowerCase() === nombreDia;
        }
        if (r.type === "date") {
          return r.value === fechaFormato;
        }
        return false;
      });
    };

    const cargarMetodosPago = () => {
        fetch(`${baseURL}/paymentMethodsGet.php?only_active=1`)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setPaymentMethods(data.payment_methods || []);
                    // Seleccionar primer método por defecto
                    if (data.payment_methods.length > 0) {
                        setPago(data.payment_methods[0]);
                    }
                }
            })
            .catch(error => console.error('Error al cargar métodos de pago:', error));
    };

    const cargarReservas = () => {
        fetch(`${baseURL}/pedidoGetAcomodacion.php`)
            .then(response => response.json())
            .then(data => {
                const pedidos = data.pedidos || [];

                const pedidosProcesados = pedidos.map(p => {
                    let productosText = "";
                    try {
                        const productosArr = typeof p.productos === "string" ? JSON.parse(p.productos) : p.productos;
                        if (Array.isArray(productosArr)) {
                            const titulos = productosArr.map(prod => {
                                return prod.titulo || prod.title || prod.name || (prod.idProducto ? `#${prod.idProducto}` : '');
                            }).filter(Boolean);
                            productosText = titulos.join(", ");
                        } else {
                            productosText = String(p.productos || "");
                        }
                    } catch (err) {
                        productosText = String(p.productos || "");
                        console.warn('Error parseando productos en pedido', p.idPedido, err);
                    }

                    return {
                        ...p,
                        productosText
                    };
                });

                setReservas(pedidosProcesados);
            })
            .catch(error => console.error('Error al cargar reservas:', error));
    };

    const limpiarFiltros = () => {
        setFiltroNombre("");
        setFiltroTelefono("");
        setFiltroFechaInicio("");
        setFiltroFechaFin("");
        setFiltroProducto("");
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return "-";
        const f = new Date(fecha);
        if (isNaN(f.getTime())) return fecha;
        return f.toLocaleDateString('es-ES');
    };

    // ------------------------- FILTROS -------------------------
    const reservasFiltradas = reservas.filter(r => {
        const nombre = (r.nombre || "").toString().toLowerCase();
        const telefono = (r.telefono || "").toString();
        const productosText = (r.productosText || "").toString().toLowerCase();

        const matchNombre = nombre.includes(filtroNombre.toLowerCase());
        const matchTelefono = filtroTelefono ? telefono.includes(filtroTelefono) : true;

        const fechaInicio = r.startDate ? r.startDate.slice(0, 10) : null;
        const fechaFin = r.finishDate ? r.finishDate.slice(0, 10) : null;

        // ----- FILTRO DE FECHA CORREGIDO (intersección) -----
        let matchFecha = true;
        const fi = filtroFechaInicio || null;
        const ff = filtroFechaFin || null;

        if (fi || ff) {
            if (!fechaInicio || !fechaFin) {
                matchFecha = false;
            } else {
                const cond1 = ff ? fechaInicio <= ff : true;
                const cond2 = fi ? fechaFin >= fi : true;
                matchFecha = cond1 && cond2;
            }
        }

        const matchProducto = filtroProducto
            ? productosText.includes(filtroProducto.toLowerCase())
            : true;

        return matchNombre && matchTelefono && matchFecha && matchProducto;
    });

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    useEffect(() => {
        if (categorias.length > 0 && productos.length > 0) {
            const categoriasAcomodacion = categorias.filter(cat => cat.categoria.includes("Acomodación"));
            const idsAcomodacion = categoriasAcomodacion.map(cat => cat.idCategoria);  
            const productosFiltrados = productos.filter(prod => idsAcomodacion.includes(prod.idCategoria)).sort((a, b) => (a.titulo || "").localeCompare(b.titulo || ""));  
            setProductosAcomodacion(productosFiltrados);  
        }  
    }, [categorias, productos]);

    useEffect(() => {
        if (!producto || !range || !range[0]) {
            setNoches(0);
            setNochesTotal(0);
            setDetallePrecios([]);
            return;
        }

        const start = new Date(range[0].startDate);
        const end = new Date(range[0].endDate);
        // noches: diferencia en días (endDate - startDate)
        const msPorDia = 1000 * 60 * 60 * 24;
        const nochesCalc = Math.max(0, Math.round((end - start) / msPorDia));

        // recorrer cada noche (noche = fechaActual desde start hasta end - 1)
        const detalle = [];
        let total = 0;
        const precioNormal = Number(producto.precio || 0);
        const precioTa = Number(producto.precio_ta || producto.precio || 0); // fallback a precio si no viene precio_ta

        let fechaActual = new Date(start);
        for (let i = 0; i < nochesCalc; i++) {
            const alta = esTemporadaAlta(fechaActual);
            const precioNoche = alta ? precioTa : precioNormal;
            detalle.push({
                fecha: fechaActual.toISOString().split('T')[0],
                precio: precioNoche,
                alta,
            });
            total += precioNoche;
            fechaActual = addDays(fechaActual, 1);
        }

        setNoches(nochesCalc);
        setDetallePrecios(detalle);
        setNochesTotal(total);

    }, [range, producto, reglas]);


    const handleGuardarReserva = async (e) => {
        e.preventDefault();
        // console.log("nochesTotal",nochesTotal);  return;
        if (!nombre || !telefono || !producto || !pago || !range[0]) {
            alert("Todos los campos son obligatorios.");
            return;
        }
        try {
            const productosPedido = [{
                tipo: "reserva",
                idProducto: producto.idProducto,
                fecha_inicio: range[0].startDate.toISOString().split("T")[0],
                fecha_fin: range[0].endDate.toISOString().split("T")[0],
                noches: nochesTotal,
                total: producto.total,
                detalle: detallePrecios,
                cantidad: 1,
                titulo: producto.titulo || "Reserva",
                items: [],
                precio: nochesTotal,
                imagen: obtenerImagen(producto)
            }];
            const productosPedidoJSON = JSON.stringify(productosPedido);

            const formData = new FormData();
            if(productosPedido[0].fecha_inicio){
                formData.append("startDate", productosPedido[0].fecha_inicio);
            }
            if(productosPedido[0].fecha_fin){
                formData.append("finishDate", productosPedido[0].fecha_fin);
            }
            formData.append("productos", productosPedidoJSON);
            formData.append("total", nochesTotal);
            formData.append("nombre", nombre);
            formData.append("telefono", telefono);
            formData.append("nota", noteText);
            formData.append("codigo", "");
            formData.append("estado", "Reservado");
            formData.append("pago", pago?.name || 'Efectivo');
            formData.append("payment_method_id", pago?.idPaymentMethod || "");
            formData.append("entrega", "Reserva en Acomodación");
            const response = await fetch(`${baseURL}/pedidoPostWithPayment.php`, {
                method: "POST",
                body: formData
            });
            const data = await response.json();
            if (data.mensaje) {
                const pedidoId = data.idPedido;
                cargarReservas();
                setNombre(""); setTelefono(""); setProductoNombre(""); setPago("");
                setNoches(0);
                setNochesTotal(0);
                setDetallePrecios([]);
                setReglas([]);
                setFechasNoDisponibles([]);
                setProducto([]);
                alert("Pedido enviado!", data.mensaje, "success");
                setModalOpen(false);  
            } else if (data?.error) {
                alert("Error", data.error, "error");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Error", "Error de conexión. Intenta nuevamente.", "error");
        }
    };
    return (
        <div className="containerReservas">

            <h2 className="mb-3">Reservas</h2>

            {/* ---------- FILTROS ---------- */}
            <div className="filtrosReservas">

                <div className="filtroItem">
                    <FontAwesomeIcon icon={faUser} className="iconoFiltro" />
                    <input
                        type="text"
                        className="inputFiltro"
                        placeholder="Buscar por cliente"
                        value={filtroNombre}
                        onChange={e => setFiltroNombre(e.target.value)}
                    />
                </div>

                <div className="filtroItem">
                    <FontAwesomeIcon icon={faPhone} className="iconoFiltro" />
                    <input
                        type="text"
                        className="inputFiltro"
                        placeholder="Teléfono"
                        value={filtroTelefono}
                        onChange={e => setFiltroTelefono(e.target.value)}
                    />
                </div>

                <div className="filtroItem">
                    <FontAwesomeIcon icon={faCalendarAlt} className="iconoFiltro" />
                    <input
                        type="date"
                        className="inputFiltroFecha"
                        value={filtroFechaInicio}
                        onChange={e => setFiltroFechaInicio(e.target.value)}
                    />
                </div>

                <div className="filtroItem">
                    <FontAwesomeIcon icon={faCalendarAlt} className="iconoFiltro" />
                    <input
                        type="date"
                        className="inputFiltroFecha"
                        value={filtroFechaFin}
                        onChange={e => setFiltroFechaFin(e.target.value)}
                    />
                </div>

                <div className="filtroItem">
                    <FontAwesomeIcon icon={faSearch} className="iconoFiltro" />
                    <input
                        type="text"
                        className="inputFiltro"
                        placeholder="Buscar por producto (titulo)"
                        value={filtroProducto}
                        onChange={e => setFiltroProducto(e.target.value)}
                    />
                </div>

                <button className="btnLimpiarFiltros" onClick={limpiarFiltros}>
                    <FontAwesomeIcon icon={faFilter} /> Limpiar
                </button>
                <button className="btnLimpiarFiltros" onClick={() => setModalOpen(true)}>
                    <FontAwesomeIcon icon={faPlus} /> Carga manual
                </button>

            </div>

            {/* ---------- TABLA ---------- */}
            <div className="tablaReservasContainer">
                <table className="tablaReservas">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Cliente</th>
                            <th>Teléfono</th>
                            <th>Producto(s)</th>
                            <th>Medio de pago</th>
                            <th>Cupon</th>
                            <th>Notas</th>
                            <th>Entrada</th>
                            <th>Salida</th>
                        </tr>
                    </thead>

                    <tbody>
                        {reservasFiltradas.length > 0 ? (
                            reservasFiltradas.map(r => (
                                <tr key={r.idPedido}>
                                    <td>{r.idPedido}</td>
                                    <td>{r.nombre}</td>
                                    <td>{r.telefono}</td>
                                    <td title={r.productosText}>{r.productosText}</td>
                                    <td>{r.pago}</td>
                                    <td>
                                        {r.codigo || r.descuento_aplicado ? (
                                            <>
                                                {r.codigo && <strong>{r.codigo}</strong>}
                                                {r.descuento_aplicado && ` — ${r.descuento_aplicado}`}
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td>{r.nota}</td>
                                    <td>{formatearFecha(r.startDate)}</td>
                                    <td>{formatearFecha(r.finishDate)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={8} className="sinDatos">
                                    No hay reservas que coincidan con los filtros.
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
            {modalOpen && (  
                <div className="modalOverlay">  
                  <div className="modalContent">  
                    <div className="modalHeader">  
                      <h3>Agregar Reserva Manual</h3>  
                      <button className="closeBtn" onClick={() => setModalOpen(false)}><FontAwesomeIcon icon={faTimes} /></button>  
                    </div>  
                    <form className="modalForm" onSubmit={handleGuardarReserva}>  
                        <label>Nombre:</label>  
                        <input type="text" placeholder="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} />  
                        <label>Teléfono:</label>  
                        <input type="text" placeholder="Teléfono" value={telefono} onChange={e => setTelefono(e.target.value)} />  
                        <label>Acomodación:</label>  
                        <select
                            value={productoNombre || ""}
                            onChange={(e) => {
                                let product = productosAcomodacion.find(p => p.idProducto.toString() === e.target.value);
                                setProducto(product);
                                let r = [];
                                try {
                                    if (product.rules_prices) {
                                        r = typeof product.rules_prices === 'string' ? JSON.parse(product.rules_prices) : product.rules_prices;
                                        if (!Array.isArray(r)) r = [];
                                    }
                                } catch (e) {
                                    console.warn("rules_prices parse error:", e);
                                    r = [];
                                }
                                setReglas(r);
                                cargarFechasNoDisponibles(e.target.value);
                                setProductoNombre(e.target.value)
                            }}

                            >
                              <option value="">Seleccionar producto</option>  
                              {productosAcomodacion.map((prod) => (  
                                <option key={prod.idProducto} value={prod.idProducto}>  
                                  {prod.titulo}  
                                </option>  
                              ))}  
                        </select>  
                        <label>Medio de pago:</label>  
                        <select
                            value={pago?.idPaymentMethod || ""}
                            onChange={(e) => {
                            const selected = paymentMethods.find(pm => pm.idPaymentMethod.toString() === e.target.value);
                            setPago(selected);
                            }}

                            >
                              <option value="">Seleccionar medio de pago</option>  
                              {paymentMethods.map(method => (  
                                <option key={method.idPaymentMethod} value={method.idPaymentMethod}>  
                                  {method.name}  
                                </option>  
                              ))}  
                        </select>
                        { producto?.idProducto && (
                            <>
                                <label>Fecha de reserva:</label>  
                                <DateRange
                                    ranges={range}
                                    onChange={(item) => {
                                        // evitar elegir fechas ocupadas
                                        if (fechaOcupada(item.selection.startDate) || fechaOcupada(item.selection.endDate)) {
                                            alert("Una o más fechas seleccionadas no están disponibles.");
                                            return;
                                        }
                                        setRange([item.selection]);
                                    }}
                                    minDate={new Date()}
                                    maxDate={addYears(new Date(), 1)}
                                    locale={es}
                                    rangeColors={["#da4a1c"]}
                                    showDateDisplay={false}
                                    dayContentRenderer={(date) => {
                                        const ocupado = fechaOcupada(date);
                                        const temporadaAlta = esTemporadaAlta(date);
                                        const precioMostrar = temporadaAlta ? Number(producto.precio_ta || producto.precio) : Number(producto.precio || 0);
                                        return (
                                            <div style={{
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: ocupado ? "#ffb3b3" : "transparent",
                                                borderRadius: "5px",
                                                width: "100%",
                                                fontWeight: ocupado ? "bold" : "normal",
                                                color: ocupado ? "#a10000" : "#000000",
                                                paddingTop: "4px",
                                            }}>
                                                {date.getDate()}
                                                <p className="price-day-calendar">${precioMostrar.toLocaleString("es-AR")}</p>
                                            </div>
                                        );
                                    }}
                                />  
                            </>
                        )}
                        <label>Nota:</label>  
                        <textarea onChange={e => setNoteText(e.target.value)} placeholder="Nota"></textarea>
                        <button type="submit" className="btnGuardar">Guardar</button>  
                    </form>  
                  </div>  
                </div>  
              )}  
        </div>
    );
}